(function ($) {
    "use strict";

    $(function () {

        var $contactForm = $('.js-contact-form');


        $('.js-reset-form').on('click', function (e) {

            e.preventDefault();
            $contactForm.trigger('reset');
            $('.fieldset-succes').hide();
            $('.fieldset-form').show();

            $('.input-wrapper').each(function () {
                $(this).removeClass('is-success');
            });

        });


        $('.js-contact-form').parsley({
            trigger: 'change',
            successClass: "is-success",
            errorClass: "is-error",
            classHandler: function (el) {
                return el.$element.closest('.input-wrapper');
            },
            errorsWrapper: '<div class="invalid-message"></div>',
            errorTemplate: '<span></span>',
        });

        //contact
        $(".js-contact-form").on("submit", function (e) {
            e.preventDefault();
            var $this = $(this);

            $(this).find(".contact-btn").prop("disabled", true);

            var formdata = $this.serializeArray();

            $.ajax({
                url: localize.ajaxurl,
                type: 'POST',
                data: {
                    action: "contact_form",
                    datas: formdata
                },
                success: function (data) {
                    var result = JSON.parse(data)
                    if (result['status'] == 'success') {
                        $('.fieldset-form').hide();
                        $('.fieldset-succes').show();
                    } else {

                        if ($('#info-modal').length) {
                            $('#info-modal').iziModal('destroy');
                        }

                        $("#info-modal").iziModal({
                            title: result["title"],
                            subtitle: result["message"],
                            icon: 'icon-power_settings_new',
                            headerColor: '#BF2236',
                            width: 600,
                            timeout: 5000,
                            timeoutProgressbar: true,
                            transitionIn: 'fadeInDown',
                            transitionOut: 'fadeOutDown',
                            pauseOnHover: true,
                            autoOpen: true,
                            radius: 0,
                        });
                    }
                }
            }).done(function (response) {
                $this.find(".contact-btn").prop("disabled", false);
            });
        });


    });

})(jQuery);